var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 10.7778C15.792 9.48 17 7.92444 17 5.88889C17 4.59228 16.5364 3.34877 15.7113 2.43192C14.8861 1.51508 13.767 1 12.6 1C11.192 1 10.2 1.44444 9 2.77778C7.8 1.44444 6.808 1 5.4 1C4.23305 1 3.11389 1.51508 2.28873 2.43192C1.46357 3.34877 1 4.59228 1 5.88889C1 7.93333 2.2 9.48889 3.4 10.7778L9 17L14.6 10.7778Z",
    stroke: "#FF8B63",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLove);
export default __webpack_public_path__ + "static/media/Icon-Love.6002d2faa1abc3be0268265989fb40e0.svg";
export { ForwardRef as ReactComponent };